import React, { useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Validator, Icon } from '../../widgets';
import { Modal, Col, Row, Form, Button } from 'react-bootstrap';
import { FormValidator } from '../../../helpers/form-validator';
import { uuid } from '../../../helpers/common';
import { addNewScoutGroup, editScoutGroup } from '../../../actions/scout-kanban';

function ScoutForm(props) {
    const { show, onHide, scoutGroupData } = props;
    const dispatch = useDispatch();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [formDetails, setFormDetails] = useState({
        scoutGroupName: scoutGroupData ? scoutGroupData.scout_group_name : "",
        geoRegionId: null,
        userId: null,
    });

    const getValidationRules = () => {
        let rules = [
            {
                field: 'scoutGroupName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Field Group Name is required'
            }
        ]

        return new FormValidator(rules);
    };

    let validator = getValidationRules();
    const [validation, setValidation] = useState(validator.valid());

    const handleChange = (event) => {
        setFormDetails({ ...formDetails, [event.target.name]: event.target.value });
    }


    const validations = useMemo(() => {
        return isSubmitted ? validator.validate(formDetails) : validation
    }, [isSubmitted, formDetails, validation]);

    const { scoutGroupName } = formDetails;

    const handleSubmit = () => {
        const validation = validator.validate(formDetails);
        setValidation(validation);
        setIsSubmitted(true);

        if (scoutGroupData) {
            const payload = {
                scout_group_uuid: scoutGroupData.scout_group_uuid,
                scout_group_name: formDetails.scoutGroupName ? formDetails.scoutGroupName : scoutGroupData.scout_group_name,
                scout_entity_type_id: scoutGroupData.scout_entity_type_id,
                scout_member: scoutGroupData.scout_member_list,
                status_id: scoutGroupData.status_id
            }
            dispatch(editScoutGroup(payload));
            onHide();
            return;
        }
        if (validation.isValid) {
            const payload = {
                scout_group_uuid: uuid(),
                scout_group_name: formDetails.scoutGroupName,
                scout_entity_type_id: 18,
                scout_member_list: [],
                status_id: 1,
                scout_uuid: uuid()
            }
            dispatch(addNewScoutGroup(payload));
            onHide();
        }
    }

    return <Modal show={show} onHide={onHide} backdrop="static" className="equipment-modal-form" size={""} >
        <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: '22px' }}>{`Add Field Group`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row >
                <Col>
                    <Form.Group>
                        <Validator validation={validations.scoutGroupName}>
                            <Form.Label htmlFor="txtCrewName">Field Group Name<Validator.Mand /></Form.Label>
                            <Form.Control type="text" id="txtCrewName" name="scoutGroupName" placeholder="Enter the Field group name"
                                maxLength='50' value={scoutGroupName} onChange={handleChange} autoComplete="off" />
                            <Validator.Text />
                        </Validator>
                    </Form.Group>
                </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button size="sm" variant="danger" onClick={onHide}>
                <Icon className="fa fa-ban" /> Cancel
            </Button>
            <Button size="sm" variant="primary" onClick={() => handleSubmit()}>
                <Icon className="fa fa-floppy-o" /> {scoutGroupData ? 'Update' : "Add"}
            </Button>
        </Modal.Footer>
    </Modal>
}

export default ScoutForm;